<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>FB广告库抓取任务配置</span>
        <div style="float: right; padding: 3px 0">
          <el-button type="primary" size="small" @click="handleSave" :loading="saving">保存配置</el-button>
          <el-button type="success" size="small" @click="handleStart" :disabled="isRunning" :loading="operating">启动</el-button>
          <el-button type="warning" size="small" @click="handlePause" :disabled="!isRunning || isPaused" :loading="operating">暂停</el-button>
          <el-button type="primary" size="small" @click="handleResume" :disabled="!isPaused" :loading="operating">恢复</el-button>
          <el-button type="danger" size="small" @click="handleStop" :disabled="!isRunning && !isPaused" :loading="operating">停止</el-button>
        </div>
      </div>
      
      <el-collapse v-model="activeCollapse">
        <el-collapse-item title="任务配置" name="config">
          <el-form ref="form" :model="form" label-width="140px" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="任务名称" prop="taskName">
                  <el-input v-model="form.taskName" placeholder="请输入任务名称" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最大页数" prop="maxPages">
                  <el-input-number v-model="form.maxPages" :min="0" :step="1" placeholder="0表示不限" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="关键字" prop="keywords">
              <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加关键字</el-button>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="存放目录" prop="saveFolderId">
                  <el-select v-model="form.saveFolderId" placeholder="选择目录" clearable filterable style="width: 100%">
                    <el-option :value="null" label="未归档" />
                    <el-option
                      v-for="folder in folderOptions"
                      :key="folder.id"
                      :label="folder.label"
                      :value="folder.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="目录规则" prop="saveFolderRule">
                  <el-select v-model="form.saveFolderRule" placeholder="选择规则" :disabled="!form.saveFolderId" style="width: 100%">
                    <el-option
                      v-for="rule in folderRuleOptions"
                      :key="rule.value"
                      :label="rule.label"
                      :value="rule.value"
                    />
                  </el-select>
                  <div style="color: #909399; font-size: 12px;">在所选目录下按年月日自动建子目录</div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="默认标签" prop="defaultTagIds">
              <el-select v-model="defaultTagIds" multiple filterable clearable placeholder="请选择默认标签" style="width: 100%">
                <el-option
                  v-for="tag in tagOptions"
                  :key="tag.id"
                  :label="tag.name"
                  :value="tag.id"
                />
              </el-select>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="搜索语言" prop="contentLanguage">
                  <el-select v-model="form.contentLanguage" placeholder="搜索语言" style="width: 100%">
                    <el-option label="英语 (en)" value="en" />
                    <el-option label="中文 (zh)" value="zh" />
                    <el-option label="全部 (all)" value="all" />
                    <el-option label="日语 (ja)" value="ja" />
                    <el-option label="韩语 (ko)" value="ko" />
                    <el-option label="西班牙语 (es)" value="es" />
                    <el-option label="法语 (fr)" value="fr" />
                    <el-option label="德语 (de)" value="de" />
                    <el-option label="葡萄牙语 (pt)" value="pt" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="媒体类型" prop="mediaType">
                  <el-select v-model="form.mediaType" placeholder="媒体类型" style="width: 100%">
                    <el-option label="图片" value="image" />
                    <el-option label="视频" value="video" />
                    <el-option label="全部" value="all" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="代理池">
              <el-tag
                :key="proxy"
                v-for="proxy in proxyTags"
                closable
                type="info"
                :disable-transitions="false"
                @close="handleProxyClose(proxy)">
                {{proxy}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="proxyInputVisible"
                v-model="proxyInputValue"
                ref="saveProxyInput"
                size="small"
                placeholder="http://ip:port"
                @keyup.enter.native="handleProxyInputConfirm"
                @blur="handleProxyInputConfirm"
                style="width: 200px"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showProxyInput">+ 添加代理</el-button>
              <div style="color: #909399; font-size: 12px; margin-top: 4px;">
                留空表示直连，格式: http://ip:port 或 socks5://ip:port 或 http://user:pass@ip:port
              </div>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="GraphQL Doc ID">
                  <el-input v-model="form.docId" placeholder="默认 25464068859919530" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="页间延迟(ms)">
                  <el-input-number v-model="form.pageDelayMs" :min="1000" :max="60000" :step="1000" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片延迟(ms)">
                  <el-input-number v-model="form.imageDelayMs" :min="100" :max="10000" :step="100" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="代理失败阈值">
                  <el-input-number v-model="form.maxFailPerProxy" :min="1" :max="10" :step="1" style="width: 100%" />
                  <div style="color: #909399; font-size: 12px;">单个代理连续失败次数达到此值后切换下一个</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      
      <div v-if="currentTaskLog" style="margin-top: 20px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
        <span style="font-weight: bold; margin-right: 20px;">当前状态: 
          <el-tag :type="statusTagType">{{ statusText }}</el-tag>
        </span>
        <span v-if="isRunning || isPaused">
           正在处理关键字: {{ currentTaskLog.lastKeyword }}
           - 第 {{ currentTaskLog.lastPage }} 页
           - 本次已抓取: {{ currentTaskLog.totalCount }} 条
        </span>
        <span v-if="currentTaskLog.errorMessage" style="color: #F56C6C; margin-left: 10px;">
          <i class="el-icon-warning"></i> {{ currentTaskLog.errorMessage }}
        </span>
      </div>

    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <div slot="header" class="clearfix">
        <span>运行日志</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="getList">刷新</el-button>
      </div>
      
      <el-table v-loading="loading" :data="logList" border style="width: 100%">
        <el-table-column label="ID" prop="id" width="80" align="center" />
        <el-table-column label="开始时间" prop="startTime" align="center" />
        <el-table-column label="结束时间" prop="endTime" align="center" />
        <el-table-column label="成功数" prop="successCount" align="center" />
        <el-table-column label="失败数" prop="failCount" align="center" />
        <el-table-column label="重复数" prop="duplicateCount" align="center" />
        <el-table-column label="总数" prop="totalCount" align="center" />
        <el-table-column label="错误信息" prop="errorMessage" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.errorMessage" style="color: #F56C6C;">{{ scope.row.errorMessage }}</span>
            <span v-else style="color: #C0C4CC;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
           <template slot-scope="scope">
              <el-tag :type="getLogStatusType(scope.row.result)">{{ getLogStatusText(scope.row.result) }}</el-tag>
           </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetails(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNo"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>

    <!-- 明细日志抽屉 -->
    <el-drawer
      title="抓取明细"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="60%"
      :wrapper-closable="true">
      <div style="padding: 20px; height: calc(100vh - 60px); display: flex; flex-direction: column; overflow: hidden;">
        <el-table v-loading="detailLoading" :data="detailList" border style="flex: 1;" height="calc(100vh - 180px)">
           <el-table-column label="关键字" prop="keyword" min-width="180" show-overflow-tooltip />
           <el-table-column label="页码" prop="pageNum" width="80" align="center" />
           <el-table-column label="本页总数" prop="totalCount" width="100" align="center" />
           <el-table-column label="成功数" prop="successCount" width="100" align="center" />
           <el-table-column label="重复数" prop="duplicateCount" width="100" align="center" />
           <el-table-column label="失败数" prop="failCount" width="100" align="center" />
           <el-table-column label="错误信息" prop="errorMessage" show-overflow-tooltip />
           <el-table-column label="抓取时间" prop="createTime" width="160" />
        </el-table>
        <pagination
          v-show="detailTotal>0"
          :total="detailTotal"
          :page.sync="detailParams.pageNo"
          :limit.sync="detailParams.pageSize"
          @pagination="getDetailList"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { 
  getTask, saveTask, startTask, pauseTask, resumeTask, stopTask, 
  getTaskLogs, getDetailLogs, getCurrentTaskLog 
} from '@/api/material/fbScrape'
import { listTags } from '@/api/material/tag'
import { listFolderTree } from '@/api/material/folder'
import Pagination from '@/components/Pagination'

export default {
  name: 'FbScrape',
  components: { Pagination },
  data() {
    return {
      // 任务配置相关
      form: {
        id: undefined,
        taskName: '',
        keywords: '[]',
        contentLanguage: 'en',
        mediaType: 'image',
        proxyPool: '[]',
        docId: '25464068859919530',
        pageDelayMs: 5000,
        imageDelayMs: 300,
        maxFailPerProxy: 2,
        maxPages: 0,
        saveFolderId: null,
        saveFolderRule: 'DATE_YMD',
        defaultTagIds: '[]'
      },
      tagOptions: [],
      folderOptions: [],
      defaultTagIds: [],
      folderRuleOptions: [
        { label: '按年月日子目录', value: 'DATE_YMD' },
        { label: '仅指定目录', value: 'FIXED' }
      ],
      dynamicTags: [],
      proxyTags: [],
      activeCollapse: [],
      inputVisible: false,
      inputValue: '',
      proxyInputVisible: false,
      proxyInputValue: '',
      saving: false,
      operating: false,
      
      // 状态相关
      currentTaskLog: null,
      timer: null,

      // 日志列表相关
      loading: false,
      logList: [],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10
      },
      
      // 明细相关
      drawerVisible: false,
      detailLoading: false,
      detailList: [],
      detailTotal: 0,
      currentLogId: null,
      detailParams: {
        pageNo: 1,
        pageSize: 20
      },

      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isRunning() {
      return this.currentTaskLog && this.currentTaskLog.result === 4
    },
    isPaused() {
      return this.currentTaskLog && this.currentTaskLog.result === 3
    },
    statusText() {
       if (!this.currentTaskLog) return '未运行'
       const statusMap = { 1: '成功', 2: '失败', 3: '暂停', 4: '进行中' }
       return statusMap[this.currentTaskLog.result] || '未知'
    },
    statusTagType() {
       if (!this.currentTaskLog) return 'info'
       const typeMap = { 1: 'success', 2: 'danger', 3: 'warning', 4: 'primary' }
       return typeMap[this.currentTaskLog.result]
    }
  },
  created() {
    this.initData()
    this.timer = setInterval(this.refreshStatus, 3000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    initData() {
      this.fetchTags()
      this.fetchFolders()
      this.getTaskConfig()
      this.getList()
      this.refreshStatus()
    },
    async fetchTags() {
      try {
        const response = await listTags({ pageSize: 1000 })
        this.tagOptions = response.data.records || response.data || []
      } catch (e) {
        this.tagOptions = []
      }
    },
    async fetchFolders() {
      try {
        const response = await listFolderTree()
        const tree = response.data || []
        this.folderOptions = this.flattenFolderOptions(tree)
      } catch (e) {
        this.folderOptions = []
      }
    },
    flattenFolderOptions(list, level = 0, result = []) {
      list.forEach(item => {
        const prefix = level > 0 ? `${'--'.repeat(level)} ` : ''
        result.push({ id: item.id, label: `${prefix}${item.name}` })
        if (item.children && item.children.length) {
          this.flattenFolderOptions(item.children, level + 1, result)
        }
      })
      return result
    },
    getTaskConfig() {
      getTask().then(res => {
        if (res.data) {
          this.form = Object.assign({}, this.form, res.data)
          try {
            this.dynamicTags = JSON.parse(res.data.keywords || '[]')
          } catch (e) {
            this.dynamicTags = []
          }
          try {
            this.proxyTags = JSON.parse(res.data.proxyPool || '[]')
          } catch (e) {
            this.proxyTags = []
          }
          try {
            const parsed = JSON.parse(res.data.defaultTagIds || '[]')
            this.defaultTagIds = Array.isArray(parsed)
              ? parsed.map(id => Number(id)).filter(id => !Number.isNaN(id))
              : []
          } catch (e) {
            this.defaultTagIds = []
          }
          if (!this.form.saveFolderRule) {
            this.form.saveFolderRule = 'DATE_YMD'
          }
        }
      })
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saving = true
          this.form.keywords = JSON.stringify(this.dynamicTags)
          this.form.proxyPool = JSON.stringify(this.proxyTags)
          this.form.defaultTagIds = JSON.stringify(this.defaultTagIds || [])
          if (!this.form.saveFolderRule) {
            this.form.saveFolderRule = 'DATE_YMD'
          }
          saveTask(this.form).then(() => {
            this.$message.success('保存配置成功')
            this.saving = false
          }).catch(() => {
            this.saving = false
          })
        }
      })
    },
    handleStart() {
      this.operating = true
      startTask().then(() => {
        this.$message.success('启动任务成功')
        this.operating = false
        this.refreshStatus()
      }).catch(() => {
        this.operating = false
      })
    },
    handlePause() {
      this.operating = true
      pauseTask().then(() => {
        this.$message.success('暂停任务成功')
        this.operating = false
        this.refreshStatus()
      }).catch(() => {
        this.operating = false
      })
    },
    handleResume() {
       this.operating = true
       resumeTask().then(res => {
         if (res.data && res.data.paramsChanged) {
           this.$message.warning('检测到参数已修改，任务将使用新参数继续运行')
         } else {
           this.$message.success('恢复任务成功')
         }
         this.operating = false
         this.refreshStatus()
       }).catch(() => {
         this.operating = false
       })
    },
    handleStop() {
      this.$confirm('确认要强制停止当前任务吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.operating = true
        stopTask().then(() => {
          this.$message.success('停止任务成功')
          this.operating = false
          this.refreshStatus()
        }).catch(() => {
          this.operating = false
        })
      })
    },
    refreshStatus() {
      getCurrentTaskLog().then(res => {
        this.currentTaskLog = res.data
      })
    },
    getList() {
      this.loading = true
      getTaskLogs(this.queryParams).then(res => {
        this.logList = res.data.records
        this.total = res.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleViewDetails(row) {
       this.currentLogId = row.id
       this.detailParams.pageNo = 1
       this.detailTotal = 0
       this.detailList = []
       this.drawerVisible = true
       this.getDetailList()
    },
    getDetailList() {
       this.detailLoading = true
       getDetailLogs({ 
         taskLogId: this.currentLogId, 
         pageNo: this.detailParams.pageNo, 
         pageSize: this.detailParams.pageSize 
       }).then(res => {
         this.detailList = res.data.records
         this.detailTotal = res.data.total
         this.detailLoading = false
       }).catch(() => {
         this.detailLoading = false
       })
    },
    
    // 关键字 Tag 方法
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    // 代理 Tag 方法
    handleProxyClose(proxy) {
      this.proxyTags.splice(this.proxyTags.indexOf(proxy), 1)
    },
    showProxyInput() {
      this.proxyInputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveProxyInput.$refs.input.focus()
      })
    },
    handleProxyInputConfirm() {
      let inputValue = this.proxyInputValue
      if (inputValue) {
        this.proxyTags.push(inputValue)
      }
      this.proxyInputVisible = false
      this.proxyInputValue = ''
    },
    
    // 状态辅助
    getLogStatusText(result) {
       const map = { 1: '成功', 2: '失败', 3: '暂停', 4: '进行中' }
       return map[result] || '未知'
    },
    getLogStatusType(result) {
       const map = { 1: 'success', 2: 'danger', 3: 'warning', 4: 'primary' }
       return map[result] || 'info'
    }
  }
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
